export const doesCurrencyHaveMarket = (marketsIds: Array<string>) => (balanceCC: string) => new Set(marketsIds.flatMap((m) => m.split('_'))).has(balanceCC);
